// extracted by mini-css-extract-plugin
module.exports = {"header":"MagazineSlider_header__L9qfj","logos":"MagazineSlider_logos__KMDnA","slide":"MagazineSlider_slide__sf_gj"};